var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDonutBase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "img-fluid",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "none",
      transformOrigin: "50% 50%",
      cursor: "move"
    },
    viewBox: "0 0 3650 3650",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1635 3628c-214-21-445-91-645-194-349-180-629-466-800-819-480-988 16-2168 1056-2514 588-196 1232-82 1710 303 109 88 264 252 346 367 84 117 197 340 242 479 177 539 98 1108-220 1587-80 120-241 296-359 393-367 300-855 446-1330 398zm350-1174c106-25 202-80 291-169 44-44 95-105 111-135 186-330 61-748-271-910-108-53-181-70-296-70-181 0-334 63-461 189-126 127-189 280-189 461 0 116 17 188 71 297 133 273 436 410 744 337z",
    fill: "current",
    style: {
      transform: "none"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonutBase);
export default __webpack_public_path__ + "static/media/donut_base.825a032fb812aae16f637e03c85b7144.svg";
export { ForwardRef as ReactComponent };